import React from 'react';
import Bg from '../../assets/images/married-1.svg';
import { ErrorInfoWrapper } from 'components/full-page-error/style';
import {
  StyledHeading1,
  NoPropertiesImageWrapper,
  StyledNoPropertyResults
} from './style';
import { Heading5 } from '@oxygen/typography';

const NoStrictMatchResults = () => (
  <StyledNoPropertyResults>
    <NoPropertiesImageWrapper>
      <Bg />
    </NoPropertiesImageWrapper>
    <ErrorInfoWrapper>
      <StyledHeading1>
        No exact matches, but we found some really close matches.
      </StyledHeading1>
      <Heading5>You can always update your search filters.</Heading5>
    </ErrorInfoWrapper>
  </StyledNoPropertyResults>
);

export default NoStrictMatchResults;
